import { render } from "./FieldDrawer.vue?vue&type=template&id=9b5b3b54&scoped=true"
import script from "./FieldDrawer.vue?vue&type=script&lang=js"
export * from "./FieldDrawer.vue?vue&type=script&lang=js"

import "./FieldDrawer.vue?vue&type=style&index=0&id=9b5b3b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5b3b54"]])

export default __exports__